// extracted by mini-css-extract-plugin
export default {"close":"dialog_close__6DA1f","textarea":"dialog_textarea__4CkoA"};